import { IsDefined, IsInt } from 'class-validator';

export class OrderFinishByAreaRequest {
    @IsDefined()
    @IsInt()
    public orderId: number;

    @IsDefined()
    @IsInt()
    public areaId: number;

    constructor(data?: Partial<OrderFinishByAreaRequest>) {
        this.orderId = data?.orderId;
        this.areaId = data?.areaId;
    }
}
